import type { NodeBase } from '../../../entities/Node';
import { MISSING_ITEMS_CATALOG } from '../../catalog/missingitems';
import { UNCATEGORIZED_CATALOG } from '../../catalog/uncategorized';
import {
  CATALOG_TYPE_BOX,
  CATALOG_TYPE_ROOMS,
  CATALOG_TYPE_STORE,
} from '../../types/catalogTypes';
import {
  NODE_TYPE_CATALOG,
  NODE_TYPE_CATEGORY,
  NODE_TYPE_ITEM,
} from '../../types/nodeTypes';
import type { CatalogConfigProps } from './DefaultCatalogConfig';
import DefaultCatalogConfig from './DefaultCatalogConfig';

export default class MasterCatalogConfig extends DefaultCatalogConfig {
  #isDraft;

  constructor(props: CatalogConfigProps) {
    super(props);

    this.#isDraft = props.catalogId !== props.productsCatalogId;
    this.allowHoverActions =
      props.isEditorForCurrentMarket || props.isBoxEditor || props.isStoreEditor;
    this.allowCopyCategory =
      props.isEditorForCurrentMarket || props.isBoxEditor || props.isStoreEditor;

    this.allowCopyToCatalog = [
      CATALOG_TYPE_BOX,
      CATALOG_TYPE_STORE,
      CATALOG_TYPE_ROOMS,
    ];

    this.allowCutCategory = this.editable && this.#isDraft;
    this.allowRanking = props.isEditorForCurrentMarket || props.isGlobalEditor;
    this.allowedSources = [props.catalogId, UNCATEGORIZED_CATALOG.catalogId];
    if (this.#isDraft) {
      this.allowedSources.push(props.productsCatalogId);
      this.allowedSources.push(MISSING_ITEMS_CATALOG.catalogId);
    } else if (props.productsDraftCatalogId) {
      this.allowedSources.push(props.productsDraftCatalogId);
    }
    this.moveDisabled = !this.#isDraft;
    this.newCategory = this.editable && this.#isDraft;
    this.canPaste = this.canPaste.bind(this);

    this.item.copy = props.isGlobalMarket;
    this.item.remove = props.isGlobalMarket && props.isEditorForCurrentMarket;
    this.item.cut = props.isGlobalMarket && props.isEditorForCurrentMarket;

    this.category.categoryType = this.editable;
    this.category.delete = this.#isDraft && this.editable;
    this.category.hide = !this.#isDraft && props.isEditorForCurrentMarket;

    this.catalog.availableForMarkets = this.#isDraft && this.editable;
    this.catalog.activateDraft = this.#isDraft && this.editable;
    this.catalog.createDraft = !this.#isDraft && this.editable;
  }

  canCopyNode = (node: NodeBase): boolean => {
    if (this.#isDraft) return true;

    if (node && node.level > 1) {
      return true;
    }

    return false;
  };

  canPaste(eventArgs: { nextParent: NodeBase; node: NodeBase }) {
    if (
      this.allowRanking &&
      this.#isDraft &&
      eventArgs.nextParent?.type === NODE_TYPE_CATALOG &&
      eventArgs.node?.type === NODE_TYPE_CATEGORY
    ) {
      return true;
    }

    if (
      this.allowRanking ||
      this.#isDraft ||
      eventArgs.node?.type === NODE_TYPE_ITEM
    ) {
      return super.canPaste(eventArgs);
    }
    return false;
  }
}
